import { Modal, Empty } from "antd";
import { Flex } from "@chakra-ui/react";
import OutlineButton from "ui/components/Button/OutlineButton";
import Historico from "./components/Historico";
import { useLoading } from "ui/components/GlobalLoading/index";
import useHistoricoEncomenda from "core/features/encomenda/hooks/useHistoricoEmail";

interface ModalHistoricoEncomendaProps {
  isOpenModal: boolean;
  onClose: () => any;
  id: string | undefined;
}

export default function ModalHistoricoEncomenda({
  id,
  isOpenModal,
  onClose,
}: ModalHistoricoEncomendaProps) {
  const { data, isFetching } = useHistoricoEncomenda(id);

  useLoading(isFetching);

  return (
    <Modal
      visible={isOpenModal}
      onCancel={onClose}
      centered
      footer={
        <Flex flex={1} justifyContent="end">
          <OutlineButton onClick={onClose}>Fechar</OutlineButton>
        </Flex>
      }
    >
      <Historico logs={data ?? []} />
      {!data?.length && !isFetching ? (
        <Empty description="Sem dados de histórico para essa encomenda" />
      ) : null}
    </Modal>
  );
}
